import { render, staticRenderFns } from "./Favorite3.vue?vue&type=template&id=47c174e8&scoped=true"
import script from "./Favorite3.vue?vue&type=script&lang=js"
export * from "./Favorite3.vue?vue&type=script&lang=js"
import style0 from "./Favorite3.vue?vue&type=style&index=0&id=47c174e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c174e8",
  null
  
)

export default component.exports